import React, { useState } from 'react';

const QuestionDisplay = ({ question, selectedOptions, onSelect, showFeedback, showCorrectness }) => {
  const [showExhibit, setShowExhibit] = useState(false);

  if (!question) return <div>Loading question...</div>;

  const isMC = question.mode === 'MC';
  const isSATA = question.mode === 'SATA';
  const isMatrix = question.mode === 'MATRIX';

  // Options for MC/SATA
  const options = ['A', 'B', 'C', 'D', 'E', 'F'].filter(opt => 
    question[`option_${opt.toLowerCase()}`]
  );

  const handleChange = (opt) => {
    if (isMC) {
      onSelect(opt);
    } else if (isSATA) {
      let newSelected = selectedOptions ? selectedOptions.split(',') : [];
      if (newSelected.includes(opt)) {
        newSelected = newSelected.filter(o => o !== opt);
      } else {
        newSelected.push(opt);
      }
      onSelect(newSelected.sort().join(','));
    }
  };

  const isSelected = (opt) => {
    if (!selectedOptions) return false;
    return selectedOptions.split(',').includes(opt);
  };

  const correctAnswers = question.correct_answer ? question.correct_answer.split(',') : [];
  const showSymbols = showFeedback || showCorrectness;

  // Matrix rendering
  if (isMatrix) {
    const columns = question.matrix_columns ? question.matrix_columns.split(',') : [];
    const rows = question.matrix_rows ? question.matrix_rows.split(';') : [];
    const correctArray = question.correct_answer ? question.correct_answer.split(',') : [];
    const selectedArray = selectedOptions ? selectedOptions.split(',') : [];

    const handleMatrixChange = (rowIndex, colValue) => {
      if (showSymbols) return; // no changes in read-only mode
      const newSelections = [...selectedArray];
      newSelections[rowIndex] = colValue;
      onSelect(newSelections.join(','));
    };

    return (
      <div>
        {question.exhibit && (
          <div className="mb-3">
            <div
              onClick={() => setShowExhibit(!showExhibit)}
              style={{
                cursor: 'pointer',
                backgroundColor: '#f0f0f0',
                padding: '8px',
                borderRadius: '4px',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <span>📋 Exhibit</span>
              <span>{showExhibit ? '▼' : '▶'}</span>
            </div>
            {showExhibit && (
              <div
                className="mt-2"
                style={{ overflowX: 'auto' }}
                dangerouslySetInnerHTML={{ __html: question.exhibit }}
              />
            )}
          </div>
        )}
        <table className="table table-bordered">
          <thead>
            <tr>
              <th></th>
              {columns.map(col => <th key={col}>{col}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIdx) => (
              <tr key={rowIdx}>
                <td>{row}</td>
                {columns.map(col => {
                  const isChecked = selectedArray[rowIdx] === col;
                  const isCorrect = showSymbols && correctArray[rowIdx] === col;
                  return (
                    <td key={col} style={{ textAlign: 'center' }}>
                      <input
                        type="radio"
                        name={`matrix-row-${rowIdx}`}
                        value={col}
                        checked={isChecked}
                        onChange={() => handleMatrixChange(rowIdx, col)}
                        disabled={showSymbols}
                      />
                      {showSymbols && isCorrect && <span style={{ color: 'green', marginLeft: 5 }}>✓</span>}
                      {showSymbols && !isCorrect && isChecked && <span style={{ color: 'red', marginLeft: 5 }}>✗</span>}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  // MC/SATA rendering
  return (
    <div>
      {question.exhibit && (
        <div className="mb-3">
          <div
            onClick={() => setShowExhibit(!showExhibit)}
            style={{
              cursor: 'pointer',
              backgroundColor: '#f0f0f0',
              padding: '8px',
              borderRadius: '4px',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <span>📋 Exhibit</span>
            <span>{showExhibit ? '▼' : '▶'}</span>
          </div>
          {showExhibit && (
            <div
              className="mt-2"
              style={{ overflowX: 'auto' }}
              dangerouslySetInnerHTML={{ __html: question.exhibit }}
            />
          )}
        </div>
      )}
      {options.map(opt => {
        const isOptSelected = isSelected(opt);
        const isOptCorrect = correctAnswers.includes(opt);

        let symbol = '';
        let symbolColor = 'transparent';
        let textColor = 'inherit';

        if (showSymbols) {
          if (isOptCorrect) {
            symbol = '✓';
            symbolColor = 'green';
            textColor = 'green';
          } else {
            symbol = '✗';
            symbolColor = 'red';
            if (isOptSelected) textColor = 'red';
          }
        }

        return (
          <div key={opt} style={{ margin: '8px 0' }}>
            <label style={{ display: 'flex', alignItems: 'center', cursor: showSymbols ? 'default' : 'pointer' }}>
              {showSymbols && (
                <span style={{ width: 20, color: symbolColor, fontWeight: 'bold', marginRight: 8 }}>
                  {symbol}
                </span>
              )}
              <input
                type={isMC ? 'radio' : 'checkbox'}
                name={isMC ? `question-${question.id}` : undefined}
                value={opt}
                checked={isOptSelected}
                onChange={() => handleChange(opt)}
                disabled={showSymbols}
                style={{ marginRight: 8 }}
              />
              <span style={{ color: textColor }}>
                {opt}. {question[`option_${opt.toLowerCase()}`]}
              </span>
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default QuestionDisplay;